import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import { ArrowLeft, Save } from "lucide-react";
import { handleUpdate, handleGet } from "../../../controllers/controller.all";
import SubmitButton from "../../../components/ui/SubmitButton";


export default function FournitureUpdate() {
    const { id } = useParams();
    const user = useSelector((state) => state.userReducer?.user);
    const token = user?.access_token || "";
    const ecoleId = user?.ecole?._id || user?.ecole;
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [classes, setClasses] = useState([]);
    const [formData, setFormData] = useState({
        classe: "",
        annee: new Date().getFullYear().toString(),
        description: ""
    });

    useEffect(() => {
        const fetchRefs = async () => {
            // Fetch classes
            await handleGet(`/classe/ecole/${ecoleId}`, (res) => {
                if (res?.classes) {
                    const ecoleClasses = res.classes.filter(c => c.ecole === ecoleId || c.ecole?._id === ecoleId);
                    setClasses(ecoleClasses);
                }
            }, token);

            // Fetch fourniture
            if (id) {
                await handleGet(`/fourniture/${id}`, (res) => {
                    if (res?.fourniture) {
                        const f = res.fourniture;
                        setFormData({
                            classe: f.classe?._id || f.classe || "",
                            annee: f.annee || "",
                            description: f.description || ""
                        });
                    }
                }, token);
            }
        };
        if(token) fetchRefs();
    }, [token, id, ecoleId]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        const payload = {
            ...formData,
            ecole: ecoleId
        };
        const res = await handleUpdate(e, `/fourniture/${id}`, payload, setLoading, token);
        if (res) {
            navigate("/fournitures");
        }
    };

    return (
        <div className="flex flex-col gap-6 max-w-2xl mx-auto">
            <div className="flex items-center gap-4">
                <Link to="/fournitures" className="p-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition text-gray-500">
                    <ArrowLeft className="h-5 w-5" />
                </Link>
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Modifier la Fourniture</h1>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="bg-white shadow-sm border border-gray-200 rounded-xl overflow-hidden">
                <div className="p-6 space-y-4">
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Description / Matériel demandé *</label>
                        <input 
                            required 
                            type="text" 
                            name="description"
                            value={formData.description} 
                            onChange={handleChange} 
                            className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" 
                            placeholder="Ex: Cahier 100 pages, Stylo bleu..." 
                        />
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-2">
                            <label className="text-sm font-medium text-gray-700">Classe *</label>
                            <select 
                                required 
                                name="classe"
                                value={formData.classe} 
                                onChange={handleChange} 
                                className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" 
                            >
                                <option value="">Sélectionnez une classe</option>
                                {classes.map(c => (
                                    <option key={c._id} value={c._id}>{c.libelle}</option>
                                ))}
                            </select>
                        </div>
                        <div className="space-y-2">
                            <label className="text-sm font-medium text-gray-700">Année scolaire *</label>
                            <input 
                                required 
                                type="text" 
                                name="annee"
                                value={formData.annee} 
                                onChange={handleChange} 
                                className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" 
                                placeholder="Ex: 2024" 
                            />
                        </div>
                    </div>
                </div>
                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
                    <Link to="/fournitures" className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition">
                        Annuler
                    </Link>
                    <SubmitButton type="submit" isSubmitting={loading} disabled={loading} className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition disabled:opacity-50">
                        <Save className="h-4 w-4" />
                        Mettre à jour
                    </SubmitButton>
                </div>
            </form>
        </div>
    );
}
